module.exports = __webpack_public_path__ + "static/media/6D.a56b3e64.jpg";